export default [
  {
    id: 1,
    url: "/enterprise/live-map",
    slug: "live-map",
    icon: "MapIcon",
    i18n: "SideMenu.Maps",
    isAddon: false,
    isFreeContent: true,
  },
  {
    id: 2,
    url: "/enterprise/plot-list",
    slug: "plot-list",
    icon: "MapPinIcon",
    localIcon: false,
    localUrl: null,
    disabledLocalUrl: require("@/assets/images/icons/lolcal/plot_lock.svg"),
    i18n: "SideMenu.Plots",
    isAddon: false,
  },
  {
    id: 8,
    url: "/enterprise/private-plot-list",
    slug: "Gkmg_Private_Plot",
    icon: null,
    localIcon: true,
    localUrl: require("@/assets/images/icons/lolcal/private_plot.svg"),
    disabledLocalUrl: require("@/assets/images/icons/lolcal/plot_lock.svg"),
    i18n: "SideMenu.PrivatePlots",
    isAddon: true,
  },
  {
    id: 3,
    url: "/enterprise/voyage-histories",
    slug: "voyage-histories",
    icon: "FilmIcon",
    localIcon: false,
    localUrl: null,
    disabledLocalUrl: require("@/assets/images/icons/lolcal/voyage_history_lock.svg"),
    i18n: "SideMenu.VoyageHistories",
    isAddon: false,
  },
  {
    id: 4,
    url: "/enterprise/management/user-list",
    slug: "users",
    icon: "UsersIcon",
    localIcon: false,
    localUrl: null,
    disabledLocalUrl: require("@/assets/images/icons/lolcal/users_lock.svg"),
    i18n: "SideMenu.Enterprise.Users",
    isAddon: false,
  },
  {
    id: 5,
    url: "/enterprise/management/vessel-list",
    slug: "vessels",
    localIcon: true,
    localUrl: require("@/assets/images/icons/lolcal/ship.svg"),
    disabledLocalUrl: require("@/assets/images/icons/lolcal/ship_lock.svg"),
    icon: "ship",
    i18n: "SideMenu.Enterprise.Vessels",
    isAddon: false,
  },
  {
    id: 6,
    url: "/enterprise/management/camera-list",
    slug: "Gkmg_Camera",
    icon: "VideoIcon",
    localIcon: false,
    localUrl: null,
    disabledLocalUrl: require("@/assets/images/icons/lolcal/camera_lock.svg"),
    i18n: "SideMenu.Enterprise.Camera",
    isAddon: true,
  },
  {
    id: 7,
    url: "/enterprise/management/notification-list",
    tag: "",
    tagColor: "primary",
    slug: "notification",
    icon: "BellIcon",
    i18n: "SideMenu.Enterprise.Notification",
    isAddon: false,
    isFreeContent: true,
  },
  {
    header: "入出港管理",
    icon: "AnchorIcon",
    i18n: "SideMenu.Enterprise.Addons.PortManagement",
    isAddon: true,
    slug: "PortMaster",
    items: [
      {
        url: "/enterprise/addon/port-master-port-menu",
        name: "Port Master",
        slug: "PortMaster",
        tagColor: "primary",
        icon: "AnchorIcon",
        i18n: "SideMenu.Enterprise.Addons.PortMaster",
        isAddon: true,
      },
      {
        url: "/enterprise/addon/gkmg-port-master-port-menu",
        name: "Port Master C",
        slug: "Gkmg_Port_Master",
        tagColor: "primary",
        icon: "AnchorIcon",
        i18n: "SideMenu.Enterprise.Addons.GkmgPortMaster",
        isAddon: true,
      },
    ],
  },
];
